export default __webpack_public_path__ + "static/cloudator-brochure-3d-inside-c298446812c7d6523fddedd1c1851ae0.jpg";